import throttle from 'lodash.throttle';
const MOBILE_VIEW = 600;
export default {
	data() {
		return {
			windowSize: {
				width: 0,
				height: 0,
			},
		};
	},
	methods: {
		handleResize: throttle(function () {
			this.getWindowSize();
		}, 100),
		getWindowSize() {
			this.windowSize = {
				height: window.innerHeight,
				width: window.innerWidth,
			};
		},
	},
	computed: {
		isMobileView() {
			if (!this.windowSize) return false;
			return this.windowSize.width > 0 && this.windowSize.width <= MOBILE_VIEW;
		},
	},
};
